import ChartConfig from "./ChartConfig";
import chartConfig from "./ChartConfig";

class ChartSupport {


	removeClass(el, className) {
		el.classList.remove(className);
	}

	addClass(el, className) {
		el.classList.add(className);
	}

	// Only for Key Figure Comparison

	getValueAllCheckedFromSelector(selector) {
		let checked = [];
		selector.forEach((el) => {
			if (el.checked) {
				checked.push(parseInt(el.value));
			}
		});
		return checked;
	}

	closeAllChartSelectToggle() {
		let elements = [...document.querySelectorAll('.closeSmartTogg')];
		elements.forEach((el) => {
			this.removeClass(el, 'checked');
		});
	}

	updateCheckboxAfterChangeSeriesHook(index, visible) {

		let context = NSContext.plugins.charts.config['kfc-chart'].config;
		let csvId = context.get.csvid;
		let exchange = context.get.exchange;
		let activeSeriesIndex = [];

		if (exchange !== 0) {
			activeSeriesIndex = context.mapping[csvId].swap.activeSeriesIndex;

		} else {
			activeSeriesIndex = context.mapping[csvId].standard.activeSeriesIndex;
		}

		let checkBoxes = document.querySelectorAll('input.smartCheckChart');
		if (activeSeriesIndex.includes(index)) {
			let searchIndex = activeSeriesIndex.indexOf(index);
			if (searchIndex !== -1) {
				activeSeriesIndex.splice(searchIndex, 1);
				checkBoxes.forEach(input => {
					if (parseInt(input.value) === index) {
						input.checked = false;
					}
				});
			}
		} else {
			activeSeriesIndex.push(parseInt(index));
			checkBoxes.forEach(input => {
				if (parseInt(input.value) === index) {
					input.checked = true;
				}
			});
		}
	}

	createChartTableView(chartId, useSeries, useCategories, useActiveSeriesIndex, useActiveCategoryIndex) {

		let header = [];
		let tblData = [];
		let csvId = NSContext.plugins.charts.config[chartId].config.get.csvid;
		let exchange = NSContext.plugins.charts.config[chartId].config.get.exchange;
		let indexed = NSContext.plugins.charts.config[chartId].config.get.indexed;
		let yaxis_title = indexed == 0 ? NSContext.plugins.charts.config[chartId].config.mapping[csvId].options.option_yaxis_title : NSContext.plugins.charts.config[chartId].config.mapping[csvId].options.option_indexed_yaxis_title;
		let yaxis_title_opposite = indexed == 0 ? NSContext.plugins.charts.config[chartId].config.mapping[csvId].options.option_yaxis_title_opposite : NSContext.plugins.charts.config[chartId].config.mapping[csvId].options.option_indexed_yaxis_title_opposite;


		//header = [...chartCategories];
		let series = JSON.parse(JSON.stringify(useSeries));
		header = JSON.parse(JSON.stringify(useCategories));
		header.unshift([]);

		let seriesLoop = 0;
		series.forEach((el, indexSeries) => {
			if (useActiveSeriesIndex.includes(indexSeries)) {
				let values = series[indexSeries].data;
				let footerNoteAdditions = series[indexSeries].label;
				let yAxis = series[indexSeries].yAxis;
				let useAxisTitle = yAxis ? yaxis_title_opposite : yaxis_title;
				let title = '';
				if (useAxisTitle != ' ') {
					title = useSeries[indexSeries].name + ' (' + useAxisTitle + ')';
				} else {
					title = useSeries[indexSeries].name;
				}

				for (let y = 0; y < series[indexSeries].data.length; y++) {
					if (indexed) {
						if (y == 0) {
							values[y] = values[y] + ' %' + footerNoteAdditions[y];
						} else {
							values[y] = (values[y] - 100).toFixed(2) + ' %' + footerNoteAdditions[y];
						}
					} else {
						let chartLocal = NSContext.plugins.charts.config[chartId].config.mapping[csvId].options.local;
						let toStringStyle = NSContext.plugins.charts.config[chartId].config.mapping[csvId].options.option_to_string_style;
						let toStringCurrency = NSContext.plugins.charts.config[chartId].config.mapping[csvId].options.option_to_string_currency_code;
						let styleOptions;
						switch (toStringStyle) {
							case 'currencySymbol':
								styleOptions = {
									style: "currency",
									currencyDisplay: "symbol",
									currency: toStringCurrency,
									useGrouping: true,
								};
								break;
							case 'currencyCode':
								styleOptions = {
									style: "currency",
									currencyDisplay: "code",
									currency: toStringCurrency,
									useGrouping: true,
								};
								break;
							case 'currencyName':
								styleOptions = {
									style: "currency",
									currencyDisplay: "name",
									currency: toStringCurrency,
									useGrouping: true,
								};
								break;
							case 'decimal':
								styleOptions = {
									style: "decimal",
									useGrouping: true,
								};
								break;
							case 'percent':
								styleOptions = {
									style: "percent",
									useGrouping: true,
								};
								break;
							case 'none':
								styleOptions = {
									useGrouping: false,
								};
								break;
						}


						values[y] = values[y].toLocaleString(chartLocal, styleOptions) + footerNoteAdditions[y];
					}

				}
				tblData[seriesLoop] = values;
				tblData[seriesLoop].unshift(title);
				seriesLoop++;
			}
		});

		tblData.unshift([...header]);

		const holder = document.getElementById('chartContainer');
		const tbl = document.createElement('table');
		tbl.setAttribute("class", "nhs-chart-table" + " csvid" + csvId);
		tbl.style.width = '100%';


		for (let i = 0; i < tblData.length; i++) {
			const tr = tbl.insertRow();
			tr.style.borderBottom = '1px solid black';
			if (i === 0) {
				tr.setAttribute('class', 'nhs-chart-table-header');
			}
			for (let j = 0; j < tblData[i].length; j++) {
				const td = tr.insertCell();
				if (j === 0) {
					td.setAttribute('colspan', '3');
				}
				td.innerHTML = tblData[i][j];
			}
		}

		holder.innerHTML = "";
		holder.appendChild(tbl);

	}

	createChartTableHidden(chartId, useSeries, useCategories, useActiveSeriesIndex, useActiveCategoryIndex) {

		let header = [];
		let tblData = [];
		let csvId = NSContext.plugins.charts.config[chartId].config.get.csvid;
		let exchange = NSContext.plugins.charts.config[chartId].config.get.exchange;
		let indexed = NSContext.plugins.charts.config[chartId].config.get.indexed;
		let yaxis_title = indexed == 0 ? NSContext.plugins.charts.config[chartId].config.mapping[csvId].options.option_yaxis_title : NSContext.plugins.charts.config[chartId].config.mapping[csvId].options.option_indexed_yaxis_title;
		let yaxis_title_opposite = indexed == 0 ? NSContext.plugins.charts.config[chartId].config.mapping[csvId].options.option_yaxis_title_opposite : NSContext.plugins.charts.config[chartId].config.mapping[csvId].options.option_indexed_yaxis_title_opposite;

		//header = [...chartCategories];
		let series = JSON.parse(JSON.stringify(useSeries));
		header = JSON.parse(JSON.stringify(useCategories));
		header.unshift([]);

		let seriesLoop = 0;
		series.forEach((el, indexSeries) => {
			if (useActiveSeriesIndex.includes(indexSeries)) {
				let values = series[indexSeries].data;
				let footerNoteAdditions = series[indexSeries].label;
				let yAxis = series[indexSeries].yAxis;
				let useAxisTitle = yAxis ? yaxis_title_opposite : yaxis_title;
				let title = useSeries[indexSeries].name + ' (' + useAxisTitle + ')';
				for (let y = 0; y < series[indexSeries].data.length; y++) {
					if (indexed) {
						if (y == 0) {
							values[y] = values[y] + ' %';
						} else {
							values[y] = (values[y] - 100).toFixed(2) + ' %';
						}
					} else {
						let chartLocal = NSContext.plugins.charts.config[chartId].config.mapping[csvId].options.local;
						let toStringStyle = NSContext.plugins.charts.config[chartId].config.mapping[csvId].options.option_to_string_style;
						let toStringCurrency = NSContext.plugins.charts.config[chartId].config.mapping[csvId].options.option_to_string_currency_code;
						let styleOptions;
						switch (toStringStyle) {
							case 'currencySymbol':
								styleOptions = {
									style: "currency",
									currencyDisplay: "symbol",
									currency: toStringCurrency,
									useGrouping: true,
								};
								break;
							case 'currencyCode':
								styleOptions = {
									style: "currency",
									currencyDisplay: "code",
									currency: toStringCurrency,
									useGrouping: true,
								};
								break;
							case 'currencyName':
								styleOptions = {
									style: "currency",
									currencyDisplay: "name",
									currency: toStringCurrency,
									useGrouping: true,
								};
								break;
							case 'decimal':
								styleOptions = {
									style: "decimal",
									useGrouping: true,
								};
								break;
							case 'percent':
								styleOptions = {
									style: "percent",
									useGrouping: true,
								};
								break;
							case 'none':
								styleOptions = {
									useGrouping: false,
								};
								break;
						}
						values[y] = values[y].toLocaleString(chartLocal, styleOptions);
					}

				}
				tblData[seriesLoop] = values;
				tblData[seriesLoop].unshift(title);
				seriesLoop++;
			}
		});


		tblData.unshift([...header]);

		const holder = document.getElementById('chartTableHidden');
		const tbl = document.createElement('table');
		tbl.setAttribute("class", "nhs-chart-table-hidden" + " csvid" + csvId);
		tbl.style.width = '100%';


		for (let i = 0; i < tblData.length; i++) {

			let row = tbl.insertRow();
			for (let j = 0; j < tblData[i].length; j++) {
				const cell = row.insertCell();
				if (j === 0) {
					cell.setAttribute('colspan', '3');
				}
				cell.innerHTML = tblData[i][j];
			}

		}

		holder.innerHTML = "";
		holder.appendChild(tbl);

	}
}

export default new ChartSupport();
